// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
  	appKey: 'Grip_DEV',
	apiUrl: 'https://apps.mvtest.online/grip/dev/api/', // 'https://localhost:5001/api',
	accessTokenType:"access_token" ,
	applicationId: 3,
	tenantId: 1,
	cloudEmailKey: 'SIN-KEY',
	auth: {
	  authority: 'https://dev-247992.oktapreview.com/oauth2/default',
	  client_id: '0oanbhqbiiTkIdiWB0h7',
	  redirect_uri: 'http://localhost:4200/auth-callback',
	  post_logout_redirect_uri: 'http://localhost:4200/logout-callback',
	  response_type: "code",
	  scope: "openid profile email",
	  filterProtocolClaims: true,
	  loadUserInfo: false
	},
	languages: [
		'es.ts',
		'en.ts'
	]
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
